import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PagingCalculator, IPagingData } from './helper/PagingCalculator';

@Component({
    selector: 'canvas-pagination',
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.scss'],
    standalone: false
})
export class PaginationComponent {

  @Input() selectedPage = 1;
  @Output() pageChange = new EventEmitter<number>();
  @Input() totalRows =  0;
  @Input() pageSize? = 0;

  pagingCalculator = new PagingCalculator();

  canPrevious = false;
  canNext = false;

  onPageChange(page: number) {
    this.selectedPage = page;
    this.pageChange.emit(this.selectedPage);
  }

  get paginationData() : IPagingData {

    const pagingCalculator = new PagingCalculator();

    const pagingData = pagingCalculator.getPageNumbers({
      maxNumberPageLinks: 10,
      currentPage: this.selectedPage,
      itemsPerPage: this.pageSize ? this.pageSize : 50,
      totalItems: this.totalRows,
    });
  
    this.canPrevious = this.selectedPage > 1;
    this.canNext = this.selectedPage < pagingData.lastPageNumber;

    // pagingData.pageNumbers = [1,2,3,4,5];
    return pagingData;
  }

}
